<template>
    <div class="tw:w-full" :class="props.customClass" :data-cy="props.dataCy">
        <ValidationProvider :name="props.name" :rules="computedRules" v-slot="{ errors }" mode="eager">
            <div class="tw:relative tw:w-full" :data-validation-error="errors[0] ? '' : undefined">
                <input
                    v-model="localValue"
                    type="email"
                    :placeholder="' '"
                    :disabled="props.disabled || props.loading"
                    class="tw:block tw:p-2 tw:pr-10 tw:w-full tw:text-sm tw:rounded tw:border tw:appearance-none tw:focus:outline-none tw:peer"
                    :class="[
                        errors[0]
                            ? 'tw:border-red-500 tw:bg-red-50/50 tw:focus:border-blue-400 tw:focus:caret-blue-400 tw:focus:text-blue-400 tw:focus:bg-white'
                            : 'tw:border-slate-300 tw:bg-white tw:focus:border-blue-400 tw:focus:caret-blue-400 tw:focus:text-blue-400'
                    ]"
                    v-bind="$attrs"
                    @input="handleInput"
                    @change="handleChange"
                />
                <span
                    v-if="props.label"
                    class="tw:absolute tw:uppercase tw:duration-300 tw:z-10 tw:pointer-events-none tw:tracking-wide tw:origin-left tw:bg-white tw:px-1
                    tw:start-1.5 tw:top-[6px] tw:-translate-y-4 tw:scale-75
                    tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:-translate-y-1/2 tw:peer-placeholder-shown:top-1/2 tw:peer-placeholder-shown:font-normal
                    tw:peer-focus:top-[6px] tw:peer-focus:-translate-y-4 tw:peer-focus:scale-75 tw:peer-focus:px-1"
                    :class="[
                        errors[0]
                            ? 'tw:text-red-400 tw:peer-placeholder-shown:bg-transparent tw:peer-focus:bg-white tw:peer-focus:text-blue-800 tw:peer-focus:font-bold'
                            : 'tw:text-slate-600 tw:font-bold tw:peer-focus:text-blue-800 tw:peer-focus:font-bold'
                    ]"
                >
                    {{ props.label }}
                </span>
            </div>

            <span
                v-if="errors[0]"
                class="tw:block tw:mt-1 tw:text-xs tw:text-red-600 tw:font-medium"
            >
                {{ formatErrorMessage(errors[0]) }}
            </span>

            <span
                v-if="props.apiValidationError && !errors[0]"
                class="tw:block tw:mt-1 tw:text-xs tw:text-red-600 tw:font-medium"
            >
                {{ Array.isArray(props.apiValidationError) ? props.apiValidationError.join(', ') : props.apiValidationError }}
            </span>
        </ValidationProvider>
    </div>
</template>

<script setup>
    import { ref, computed, watch } from 'vue';

    const props = defineProps({
        label: String,
        name: String,
        rules: [String, Object],
        value: [String, Number],
        disabled: Boolean,
        loading: Boolean,
        apiValidationError: [String, Array],
        customClass: String,
        dataCy: String
    });

    const emit = defineEmits(['input', 'change']);

    const computedRules = computed(() => {
        const base = props.rules || '';
        return base ? `${base}|email` : 'email';
    });

    const localValue = ref(props.value != null ? String(props.value) : '');

    const formatErrorMessage = err => {
        const msg = typeof err === 'string' ? err : (err && err.message) || String(err || '');
        return msg ? msg.charAt(0).toUpperCase() + msg.slice(1).toLowerCase() : '';
    };

    const handleInput = e => {
        emit('input', e.target.value);
    };

    const handleChange = e => {
        emit('change', e.target.value);
    };

    watch(() => props.value, newVal => {
        if (newVal !== localValue.value) {
            localValue.value = newVal != null ? String(newVal) : '';
        }
    });
</script>

<script>
    export default {
        inheritAttrs: false
    };
</script>
